import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import sanitizedContentData from '@/components/shared/utils/sanitizedContentData'
import { motion } from 'framer-motion'
import { useMediaQuery } from '@uidotdev/usehooks'
// styles
import './styles.ocm.scss'

export default function OurCommitment({ data }) {
  const isExtraLargeDevice = useMediaQuery('only screen and (min-width : 1200px)')
  const subTitle = get(data, ['subTitle'], '')
  const title = get(data, ['title'], '')
  const content = get(data, ['content'], '')

  return (
    <section className="mainSectionOurCommit">
      <div className="containerOurCommit">
        <div className="separatorDiv" />
        <div className="containerContent">
          <motion.div
            style={{
              position: 'relative',
            }}
            transition={{
              duration: 0.7,
              delay: 0.2,
            }}
            viewport={{
              once: true,
            }}
            initial={{ opacity: 0, bottom: '-70px' }}
            whileInView={{ opacity: 1, bottom: '0px' }}
            exit={{ opacity: 0 }}
            className="containerTitles"
          >
            <pre>{subTitle}</pre>
            <h2 dangerouslySetInnerHTML={sanitizedContentData(title)} />
          </motion.div>
          <motion.div
            style={{
              position: 'relative',
              width: `${!isExtraLargeDevice ? '100' : content.width_content}%`,
            }}
            transition={{
              duration: 0.7,
              delay: 0.3,
            }}
            viewport={{
              once: true,
            }}
            initial={{ opacity: 0, bottom: '-70px' }}
            whileInView={{ opacity: 1, bottom: '0px' }}
            exit={{ opacity: 0 }}
            className="containerParagraph"
            dangerouslySetInnerHTML={sanitizedContentData(content.text)}
          />
        </div>
        <div className="separatorDiv" />
      </div>
    </section>
  )
}

OurCommitment.propTypes = {
  data: PropTypes.object,
}
